import { filterStyles } from "@insite/content-library/Widgets/OrderApprovalList/OrderApprovalListFilter";
import { tableStyles } from "@insite/content-library/Widgets/OrderApprovalList/OrderApprovalListTable";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { css } from "styled-components";

filterStyles.clearFiltersButton = {
    mergeCss: true,
    variant: "secondary",
    css: css`
        margin-right: 10px;
    `,
};

filterStyles.appliedFilterTag = {
    css: css`
        button {
            min-width: auto;
            &:hover {
                border: none !important;
                background: none !important;
            }
            &:focus {
                outline: none !important;
            }
        }
    `,
};

tableStyles.container = {
    css: css`
        overflow: auto;
        margin-top: 30px !important;
    `,
};

filterStyles.fromDate={
    cssOverrides: {
        formField: css`
            width: 100%;
        `,
        formInputWrapper: css`
            @media (min-width: 992px) and (max-width: 1100px) {
                div[class^="react-datetime-picker"]{
                    padding-left:0px !important;
                }
                span[class^="IconWrapper"] {
                    padding-left: 2px !important;
                    width: 30px !important;
                }
            }
        `,
    },
}

filterStyles.toDate= {
        cssOverrides: {
            formField: css`
                width: 100%;
            `,
            formInputWrapper: css`
                div[class^="react-calendar"]{
                    ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        null,
                        null,
                        null,
                        css`
                            left: auto;
                            right: 0;
                        `,
                        css`
                            left: auto;
                            right: 0;
                        `,
                    ])}
                }
                @media (min-width: 992px) and (max-width: 1100px) {
                    div[class^="react-datetime-picker"]{
                        padding:0px !important;
                    }
                    span[class^="IconWrapper"] {
                        padding-left: 2px !important;
                        width: 30px !important;
                    }
                }
            `,
        },
}
